<template>
  <div>
    <div>
      <div class="box box-primary">
        <div class="box-body">
          <div class="col-md-12" style="margin-top: 15px">
            <div>
              <label v-if="!isHideApartmentList" for="">{{ $t("apartment.title") }}</label>
            </div>
            <div class="col-md-12" v-if="apartmentBookingStatus !== BookingActionEnum.CANCEL">
              <div class="row form-group">
                <button
                  v-if="apartmentSelectStatus === BookingActionEnum.CHECKED_IN && !isHideApartmentList"
                  type="button"
                  class="btn btn-warning pull-right"
                  @click="onClickCheckOutApartment"
                >
                  <span class="btn-label">
                    <i class="fa fa-calendar-minus-o"></i>
                  </span>
                  {{ $t("context_menu.checkout") }}
                </button>
                <button
                  v-if="checkShowCheckInBtn(apartmentSelectStatus)"
                  type="button"
                  class="btn btn-success pull-right"
                  @click="onClickCheckInApartment"
                  style="margin-right: 5px"
                >
                  <span class="btn-label">
                    <i class="fa fa-calendar-check-o"></i>
                  </span>
                  {{ $t("context_menu.checkin") }}
                </button>
              </div>
            </div>
            <div class="row">
              <div v-if="!isHideApartmentList" class="col-sm-12 col-md-4">
                <div>
                  <b-table
                    class="apartment-in-booking-table"
                    striped
                    hover
                    responsive
                    :tbody-tr-class="rowClass"
                    :sticky-header="`${screenHight}px`"
                    :items="apartmentListInBooking"
                    :fields="productFields"
                    @row-clicked="onRowSelected"
                    ref="apartmentInBookingTable"
                  >
                    <template #head()="scope">
                      <div class="">{{ $t(scope.label) }}</div>
                    </template>
                    <template #cell(bookingStatus)="row">
                      <span
                        :style="`color: ${getColor(row.item.bookingStatus)}`"
                        >{{ $t(getStatus(row.item.bookingStatus)) }}</span
                      >
                    </template>
                    <!-- <template #cell(actions)="row">
                      <button
                        class="btn btn-primary btn-sm"
                        style="margin-left: 6px;"
                        @click="onOpenEditProductInApartment(row.item)"
                      >
                        <i class="glyphicon glyphicon-plus"></i>
                      </button>
                    </template> -->
                  </b-table>
                </div>
              </div>
              <div :class="`${!isHideApartmentList ? 'col-sm-12 col-md-8' : 'col-md-12'}`">
                <div>
                  <div class="col-md-12">
                    <div class="row">
                      {{ $t("apartmentBooking.customerList") }}
                      <button
                        v-if="
                          apartmentIdSelect &&
                            apartmentSelectStatus !==
                              BookingActionEnum.CHECK_OUT
                        "
                        type="button"
                        class="btn btn-primary pull-right"
                        @click="onClickAddUserInApartment"
                      >
                        <span class="btn-label">
                          <i class="fa fa-plus"></i>
                        </span>
                        {{ $t("common.addnew") }}
                      </button>
                    </div>
                  </div>
                  <div class="col-md-12">
                    <div class="row">
                      <b-table
                        striped
                        hover
                        responsive
                        :tbody-tr-class="rowClass"
                        :sticky-header="`${screenHight}px`"
                        :items="userBookingInApartment"
                        :fields="userBookingInApartmentFields"
                      >
                        <template #head()="scope">
                          <div class="">{{ $t(scope.label) }}</div>
                        </template>
                        <template #cell(actions)="row">
                          <button
                            v-if="
                              apartmentIdSelect &&
                                apartmentSelectStatus !==
                                  BookingActionEnum.CHECK_OUT
                            "
                            class="btn btn-danger btn-sm"
                            style="margin-left: 6px;"
                            @click="
                              onOpenDeleteUserBookingInApartment(row.item)
                            "
                          >
                            <i class="glyphicon glyphicon-trash"></i>
                          </button>
                        </template>
                      </b-table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- modal -->
    <div
      class="modal fade"
      :ref="`modal-user-list-in-booking`"
      data-keyboard="false"
      data-backdrop="static"
    >
      <div class="modal-dialog modal-lg modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <button
              type="button"
              class="close"
              aria-label="Close"
              @click="onCloseUserListInBookingModal"
            >
              <span aria-hidden="true">&times;</span>
            </button>
            <h4 class="modal-title">
              {{ $t("apartmentBooking.addUserBookingInApartment") }}
            </h4>
          </div>
          <div class="modal-body">
            <div class="row"></div>
            <div class="row" style="margin-top: 15px">
              <div class="col-md-12">
                <div>
                  <b-table
                    :items="userInBookingList"
                    :fields="userInBookingFields"
                    class="mt-3"
                    responsive
                    outlined
                    selectable
                    @row-selected="onSelectUser"
                    select-mode="single"
                    ref="apartmentSearchInBooking"
                  >
                    <template #head()="scope">
                      <div>{{ $t(scope.label) }}</div>
                    </template>
                    <!-- <template #cell(numberOfRoomChoose)="row">
                      <input
                        type="number"
                        class="form-control"
                        v-model="row.item.numberOfRoomChoose"
                        @input="
                          inputApartmentNumberOfRoom(
                            row.item.quantity,
                            row.item.numberOfRoomChoose
                          )
                        "
                      />
                    </template> -->
                  </b-table>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button
              style="background-color: #f29911;border-color: #f29911;color:#fff"
              type="button"
              class="btn btn-default pull-left"
              @click="onCloseUserListInBookingModal"
            >
              {{ $t("common.back") }}
            </button>
            <button
              type="button"
              class="btn btn-primary"
              @click="onClickAddUserBookingInApartment"
            >
              {{ $t("common.save") }}
            </button>
          </div>
        </div>
      </div>
      <lte-core-alert
        v-for="snackbar in GET_SNACK_BAR"
        :key="snackbar.id"
        :item="snackbar"
      ></lte-core-alert>
    </div>
    <!-- modal confirm check-in -->
    <lte-modal
      v-show="isModalCheckInVisible"
      @onConfirm="onConfirmCheckIn"
      @close="closeModalCheckIn"
      v-for="obj in objModalCheckIn"
      :key="obj.id"
      :item="obj"
    ></lte-modal>
    <!-- modal delete user booking in apartment -->
    <lte-modal
      v-show="isModalDeleteUserBookingVisible"
      @onConfirm="onConfirmDeleteUserBooking"
      @close="closeModalDeleteUserBooking"
      v-for="obj in objModalDeleteUserBooking"
      :key="obj.id"
      :item="obj"
    ></lte-modal>
    <!-- modal confirm check out -->
    <lte-modal
      v-show="isModalCheckOutVisible"
      @onConfirm="onConfirmCheckOut"
      @close="closeModalCheckOut"
      v-for="obj in objModalCheckOut"
      :key="obj.id"
      :item="obj"
    ></lte-modal>
    <check-out-modal ref="checkOutModal"
      :bookingId="bookingId"
      :apartmentId="apartmentIdSelect"
      @callBackDataCheckOut="callBackCheckOut"
    />
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import utils from "@/lib/utils";
import constantsData from "@/lib/constantsData";
import BookingActionEnum from "@/enum/bookingActionEnum";
import LTECoreAlert from "@/components/LTESnackBar.vue";
import LTEModal from "@/components/LTEModal.vue";
import CheckOutModal from './CheckOutModal'
import moment from 'moment';

export default {
  components: {
    "lte-core-alert": LTECoreAlert,
    "lte-modal": LTEModal,
    CheckOutModal
  },
  props: {
    bookingId: {
      type: Number,
      default: () => {
        return null;
      }
    },
    isHideApartmentList: {
      type: Boolean,
      default: () => {
        return false;
      }
    },
    apartmentIdProps: {
      type: Number,
      default: () => {
        return null;
      }
    }
  },
  data: () => ({
    screenHight: 0,
    apartmentBookingStatusList: constantsData.apartmentBookingStatusList,
    BookingActionEnum: BookingActionEnum,
    // apartment list
    productFields: [
      {
        key: "nonumber",
        label: "common.nonumber"
      },
      {
        key: "apartmentName",
        label: "apartment.apartmentName"
      },
      {
        key: "bookingStatus",
        label: "apartment.status"
      }
    ],
    rowSelected: null,
    apartmentListInBooking: [],
    apartmentIdSelect: null,
    apartmentSelectStatus: null,
    // user booking in apartment
    userBookingInApartment: [],
    userBookingInApartmentFields: [
      {
        label: "common.nonumber",
        key: "nonumber",
        class: "text-center "
      },
      {
        label: "apartmentBooking.customerName",
        key: "customerName",
        class: "text-center "
      },
      {
        label: "user_guest.identification",
        key: "identificationnumber",
        class: "text-center "
      },
      {
        label: "customer.phone",
        key: "customerPhone",
        class: "text-center "
      },
      {
        label: "common.email",
        key: "customerEmail",
        class: "text-center "
      },
      { key: "actions", label: "common.action" }
    ],
    isModalDeleteUserBookingVisible: false,
    userBookingSelect: null,
    objModalDeleteUserBooking: [
      {
        title: "common.delete_modal.title",
        body: "common.delete_modal.content",
        buttonNo: "common.delete_modal.btnNo",
        buttonYes: "common.delete_modal.btnYes",
        styleType: "default"
      }
    ],
    // add user booking in apartment
    userInBookingList: [],
    userInBookingFields: [
      {
        label: "common.nonumber",
        key: "nonumber",
        class: "text-center "
      },
      // {
      //   label: "apartmentBooking.isManCustomer",
      //   key: "isManCustomerBooking",
      //   class: "text-center "
      // },
      {
        label: "apartmentBooking.customerName",
        key: "customerName",
        class: "text-center "
      },
      {
        label: "user_guest.identification",
        key: "identificationnumber",
        class: "text-center "
      },
      {
        label: "customer.phone",
        key: "customerPhone",
        class: "text-center "
      },
      {
        label: "common.email",
        key: "customerEmail",
        class: "text-center "
      }
    ],
    userInBookingSelect: null,
    // action check in
    isModalCheckInVisible: false,
    objModalCheckIn: [
      {
        title: "apartmentBooking.checkInModal.title",
        body: "apartmentBooking.checkInModal.body",
        buttonNo: "common.delete_modal.btnNo",
        buttonYes: "common.delete_modal.btnYes",
        styleType: "default"
      }
    ],
    // action check out
    isModalCheckOutVisible: false,
    objModalCheckOut: [
      {
        title: "apartmentBooking.checkOutModal.title",
        body: "apartmentBooking.checkOutModal.body",
        buttonNo: "common.delete_modal.btnNo",
        buttonYes: "common.delete_modal.btnYes",
        styleType: "default"
      }
    ],
    apartmentBookingStatus: null,
    apartmentBookingData: {
      checkOutDate: null
    }
  }),
  watch: {
    GET_APARTMENT_LIST_IN_BOOKING_DATA: function() {
      let data = this.GET_APARTMENT_LIST_IN_BOOKING_DATA;
      this.apartmentListInBooking = [];
      data.forEach((value, index) => {
        let item = {
          nonumber: index + 1,
          id: value.id,
          apartmentName: utils.getCleanStringValue(value.apartment_name, value.apartment_code),
          bookingStatus: value.booking_status
        };
        this.apartmentListInBooking.push(item);
      });
      this.onSelectApartment()
    },
    GET_USER_BOOKING_IN_APARTMENT_DATA: function() {
      let data = this.GET_USER_BOOKING_IN_APARTMENT_DATA;
      this.userBookingInApartment = [];
      data.forEach((value, index) => {
        let item = {
          nonumber: index + 1,
          id: value.id,
          customerName: value.full_name,
          identificationnumber: value.identificationnumber,
          customerPhone: value.phone,
          customerEmail: value.email
        };
        this.userBookingInApartment.push(item);
      });
    },
    GET_USER_LIST_IN_BOOKING_DATA: function() {
      let data = this.GET_USER_LIST_IN_BOOKING_DATA;
      this.userInBookingList = [];
      data.forEach((value, index) => {
        let item = {
          nonumber: index + 1,
          id: value.id,
          customerName: value.full_name,
          identificationnumber: value.identificationnumber,
          customerPhone: value.phone,
          customerEmail: value.email
        };
        this.userInBookingList.push(item);
      });
    },
    GET_APARTMENT_BOOKING_DETAIL_DATA: function() {
      let data = this.GET_APARTMENT_BOOKING_DETAIL_DATA
      this.apartmentBookingStatus = data.status
      this.apartmentBookingData.checkOutDate = moment(data.checkout_datetime)
    },
    apartmentIdProps: function() {
      this.onGetDataApartmentIdProps(this.apartmentIdProps, this.bookingId)
    }
  },
  computed: {
    ...mapGetters([
      "GET_SNACK_BAR",
      "GET_APARTMENT_LIST_IN_BOOKING_DATA",
      "GET_USER_BOOKING_IN_APARTMENT_DATA",
      "GET_USER_LIST_IN_BOOKING_DATA",
      "GET_APARTMENT_BOOKING_DETAIL_DATA"
    ])
  },
  methods: {
    checkShowCheckInBtn: function(apartmentSelectStatus) {
      if (moment() > this.apartmentBookingData.checkOutDate) {
        return false
      } else if (apartmentSelectStatus ===
        BookingActionEnum.WAITING_CHECK_IN ||
        apartmentSelectStatus === null) {
        return true
      } else return false
    },
    handleResize() {
      this.screenHight =
        window.innerHeight - 382 > 300 ? window.innerHeight - 382 : 300;
    },
    onShowError: function(mess) {
      this.ON_SHOW_TOAST({
        message: mess,
        styleType: "danger"
      });
    },
    //
    // apartement in booking list
    //
    getApartmentListInBooking: function(bookingId) {
      let filter = {
        params: {
          bookingId: bookingId
        }
      };
      this.GET_APARTMENT_LIST_IN_BOOKING(filter);
    },
    getStatus: function(value) {
      let index = this.apartmentBookingStatusList.findIndex(
        x => x.value === value
      );
      return index !== -1 ? this.apartmentBookingStatusList[index].text : null;
    },
    getColor: function(value) {
      if (value === BookingActionEnum.WAITING_CHECK_IN) {
        return "#006ad4";
      } else if (value === BookingActionEnum.CANCEL) {
        return "#f2404d";
      } else if (value === BookingActionEnum.CHECKED_IN) {
        return "#26ba50";
      } else if (value === BookingActionEnum.CHECK_OUT) {
        return "#f29911";
      }
    },
    rowClass(item, type) {
      if (!item || type !== "row") return;
      if (item.nonumber === this.rowSelected) return "row-booking-cancel";
    },
    onRowSelected: function(items, index) {
      this.rowSelected = index + 1;
      this.apartmentIdSelect = items.id;
      this.apartmentSelectStatus = items.bookingStatus;
      this.getUserListInBooking();
      this.getUserBookingInApartment();
      this.getProductInApartmentList(items.id)
    },
    //
    // user
    //
    getUserListInBooking: function() {
      let filter = {
        params: {
          bookingId: this.bookingId,
          excludeUserInRoom: true
        }
      };
      this.GET_USER_LIST_IN_BOOKING(filter);
    },
    onCloseUserListInBookingModal: function() {
      $(this.$refs[`modal-user-list-in-booking`]).modal("hide");
    },
    onShowUserListInBookingModal: function() {
      $(this.$refs[`modal-user-list-in-booking`]).modal("show");
    },
    onClickAddUserInApartment: function() {
      this.onShowUserListInBookingModal();
    },
    onSelectUser: function(items) {
      this.userInBookingSelect = items[0];
    },
    onClickAddUserBookingInApartment: function() {
      if (utils.isEmptyString(this.userInBookingSelect)) {
        this.onShowError(this.$t("apartmentBooking.errorSelectUser"));
      } else {
        //
        let data = {
          id: this.userInBookingSelect && this.userInBookingSelect.id,
          apartmentId: this.apartmentIdSelect,
          bookingId: this.bookingId
        };
        this.ADD_USER_BOOKING_IN_APARTMENT(data)
          .then(
            function() {
              this.getUserListInBooking();
              this.getUserBookingInApartment();
              this.onCloseUserListInBookingModal();
              this.SUCCESS_TOAST();
            }.bind(this)
          )
          .catch(
            function() {
              this.ERROR_TOAST();
            }.bind(this)
          );
      }
    },
    //
    // user booking in apartment
    //
    getUserBookingInApartment: function() {
      let filter = {
        params: {
          bookingId: this.bookingId,
          apartmentId: this.apartmentIdSelect
        }
      };
      this.GET_USER_BOOKING_IN_APARTMENT(filter);
    },
    onOpenDeleteUserBookingInApartment: function(data) {
      this.userBookingSelect = data;
      this.isModalDeleteUserBookingVisible = true;
    },
    closeModalDeleteUserBooking: function() {
      this.isModalDeleteUserBookingVisible = false;
    },
    onConfirmDeleteUserBooking: function() {
      this.REMOVE_USER_BOOKING_IN_APARTMENT(this.userBookingSelect)
        .then(
          function() {
            this.getUserListInBooking();
            this.getUserBookingInApartment();
            this.closeModalDeleteUserBooking();
            this.SUCCESS_TOAST();
          }.bind(this)
        )
        .catch(
          function() {
            this.ERROR_TOAST();
          }.bind(this)
        );
    },
    //
    // action check in
    //
    onClickCheckInApartment: function() {
      if (utils.isEmptyString(this.apartmentIdSelect)) {
        this.onShowError(
          this.$t("apartmentBooking.errorSelectApartmentBookingList")
        );
      } else if (this.userBookingInApartment.length === 0) {
        this.onShowError(
          this.$t("apartmentBooking.errorNotFoundUserInApartment")
        );
      } else {
        // show modal confirm check in
        this.isModalCheckInVisible = true;
      }
    },
    // confirm check in
    closeModalCheckIn: function() {
      this.isModalCheckInVisible = false;
    },
    onConfirmCheckIn: function() {
      let data = {
        apartmentId: this.apartmentIdSelect,
        bookingId: this.bookingId
      };
      this.CHECK_IN_APARTMENT_IN_BOOKING(data)
        .then(
          function(res) {
            let data = res.data;
            this.emitCallBackApartmentDiagram()
            this.getApartmentListInBooking(this.bookingId);
            this.closeModalCheckIn();
            this.apartmentSelectStatus = data.status;
            this.SUCCESS_TOAST();
          }.bind(this)
        )
        .catch(
          function() {
            this.ERROR_TOAST();
          }.bind(this)
        );
    },
    //
    // action check out
    //
    onClickCheckOutApartment: function() {
      this.$refs.checkOutModal.onShowModal()
      // this.isModalCheckOutVisible = true;
    },
    closeModalCheckOut: function() {
      this.isModalCheckOutVisible = false;
    },
    onConfirmCheckOut: function() {
      let data = {
        apartmentId: this.apartmentIdSelect,
        bookingId: this.bookingId
      };
      this.CHECK_OUT_APARTMENT_IN_BOOKING(data)
        .then(
          function(res) {
            let data = res.data;
            this.getApartmentListInBooking(this.bookingId);
            this.closeModalCheckOut();
            this.apartmentSelectStatus = data.status;
            this.SUCCESS_TOAST();
          }.bind(this)
        )
        .catch(
          function() {
            this.ERROR_TOAST();
          }.bind(this)
        );
    },
    callBackCheckOut: function(data) {
      this.getApartmentListInBooking(this.bookingId);
      this.apartmentSelectStatus = data;
    },
    getProductInApartmentList: function(apartmentId) {
      let filter = {
        params: {
          apartmentId: apartmentId
        }
      };
      this.GET_PRODUCT_IN_APARTMENT_TYPE_LIST(filter);
    },
    onGetDataApartmentIdProps: async function(apartmentId, bookingId) {
      if (bookingId){
        await this.getApartmentListInBooking(bookingId)
      }
    },
    onSelectApartment: function() {
      if (this.apartmentIdProps && this.bookingId) {
        if (this.apartmentListInBooking.length > 0 ){
          let index = this.apartmentListInBooking.findIndex(x=>x.id === this.apartmentIdProps)
          if (index !== -1) {
            this.GET_APARTMENT_BOOKING_DETAIL({id: this.bookingId})
            this.onRowSelected(this.apartmentListInBooking[index], index)
          }
        }
      }
    },
    emitCallBackApartmentDiagram: function(){
      if(this.apartmentIdProps) {
        this.$emit('callBackApartmentDiagram', true)
      }
    },
    ...mapActions([
      "ON_SHOW_TOAST",
      "SUCCESS_TOAST",
      "ERROR_TOAST",
      "GET_APARTMENT_LIST_IN_BOOKING",
      "GET_USER_LIST_IN_BOOKING",
      "GET_USER_BOOKING_IN_APARTMENT",
      "ADD_USER_BOOKING_IN_APARTMENT",
      "REMOVE_USER_BOOKING_IN_APARTMENT",
      "CHECK_IN_APARTMENT_IN_BOOKING",
      "CHECK_OUT_APARTMENT_IN_BOOKING",
      "GET_PRODUCT_IN_APARTMENT_TYPE_LIST",
      "GET_APARTMENT_BOOKING_DETAIL"
    ])
  },
  created() {
    window.addEventListener("resize", this.handleResize);
    this.handleResize();
  }
};
</script>
<style lang="scss" scoped>
.apartment-in-booking-table :deep(.b-table .row-booking-cancel) {
  background-color: #cccccc;
  // border: 1px solid blue;
}
</style>



// WEBPACK FOOTER //
// src/views/ApartmentBooking/ApartmentInBooking.vue